// components/AuthGate.jsx
import { useContext, useEffect, useState } from "react";
import AuthContext from "../context/authContext";
import { Navigate } from "react-router-dom";
import TeacherDashboard from "../pages/dashboard/TeacherDashboard";
import StudentDashboard from "../pages/dashboard/StudentDashboard";
import PublicHome from "../pages/PublicHome";
import Activities from "../pages/Activities";
import {unloadUnityWebGL, unityContext} from "../context/unityContext";

const AuthGate = () => {
  const { currentUser, loading } = useContext(AuthContext);
  const [showAuth, setShowAuth] = useState(false);

  useEffect(() => {
    if (unityContext) unloadUnityWebGL();
    if (!loading && !currentUser) {
     setShowAuth(false);
  }
}, [currentUser, loading]);

  // CASE not logged in show public homepage
  if (!currentUser) {
    return (
      <>
        <PublicHome />
      </>
    );
  }

  // 👇 CASE Logged in show dashboards
  return currentUser.role === 0 || currentUser.role === 1 ? (
    <TeacherDashboard />
  ) : (
    <Navigate to="/activities" replace />
  );
};

export default AuthGate;
